<template>
  <div class="login-step login-step-mobile">
    <h1 class="step-title">{{ $t('lbl_emp2_SupplierLoginHere') }}</h1>
    
    <form @submit.prevent="handleEnter" autocomplete="on">
      <div class="form-group">
        <div class="input-wrapper">
          <selection 
            style="margin-bottom: 0px;"
            :title="$t('lbl_emp2_CountryRegion')" 
            label="Name"
             class="mobile-country-select"
            :value="countryCode" 
            :options="normalizedCountryOptions" 
            :ControlId="'mobile-country-select'" 
            :multiple="false" 
            @input="handleCountryCodeInput"
            @fromChird_TreeSelected="handleCountrySelected($event)">
          </selection>
        </div>
        <div class="input-wrapper">
          <div class="input-container-placeholder" :class="{ 'input-error': mobileError }">
            <!-- 浮动标签（有值或错误时显示在边框上方） -->
            <label v-if="mobileError || mobileNumber" class="input-label" :class="{ 'label-error': mobileError }">
              {{ $t('lbl_emp2_MobileNumber') }} <span class="required">*</span>
            </label>
            <!-- 占位符（无值时显示在输入框内部） -->
            <span v-if="!mobileNumber && !mobileError" class="input-placeholder">
              {{ $t('lbl_emp2_MobileNumber') }} <span class="required">*</span>
            </span>
            <input
              style="height: 36px;;"
              :value="mobileNumber"
              type="tel"
              name="tel"
              id="tel-field"
              autocomplete="tel"
              class="form-input-placeholder"
              :class="{ 'input-error': mobileError }"
              placeholder=""
              @focus="$emit('clear-mobile-error')"
              @input="handleInput"
              @keydown.enter.prevent="handleEnter"
            />
          </div>
          <!-- 错误信息 -->
          <div v-if="mobileError" class="mobile-error-message">
            {{ $t('lbl_emp2_InvalidMobileNumber') }}
          </div>
        </div>
      </div>

      <button
        type="submit"
        class="btn-primary"
        :disabled="!isValidMobile || loading"
        t_label="btn_emp2_Continue_Mobile"
      >
        {{ $t('lbl_emp2_Continue') }}
      </button>
    </form>

    <slot name="divider">
      <div class="divider">
        <span>{{ $t('lbl_emp2_OR') }}</span>
      </div>
    </slot>

    <slot name="alternative-login">
      <div class="alternative-login">
        <button class="btn-secondary" @click="$emit('switch-login', 'username')" t_label="btn_emp2_LoginWithUsername_FromMobile">
          {{ $t('lbl_emp2_LoginWithUsername') }}
        </button>
        <button class="btn-secondary" @click="$emit('switch-login', 'email')" t_label="btn_emp2_LoginWithEmail_FromMobile">
          {{ $t('lbl_emp2_LoginWithEmail') }}
        </button>
      </div>
    </slot>

    <!-- SSO 登录暂时隐藏 -->
    <!-- <slot name="sso-login">
      <div class="sso-login">
        <button class="sso-btn wechat" @click="$emit('wechat-login')" title="Login with WeChat">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/wechat_icon.png" alt="WeChat" />
        </button>
        <button class="sso-btn google" @click="$emit('google-login')" title="Login with Google">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/google_icon.png" alt="Google" />
        </button>
        <button class="sso-btn linkedin" @click="$emit('linkedin-login')" title="Login with LinkedIn">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/linkedin_icon.png" alt="LinkedIn" />
        </button>
      </div>
    </slot> -->

    <slot name="become-supplier">
      <div class="become-supplier">
        <span>{{ $t('lbl_emp2_NotASupplierMember') }}</span>
        <a
          href="#"
          @click.prevent="$emit('show-become-supplier')"
          class="supplier-link"
        >
          {{ $t('lbl_emp2_ApplyForMembership') }} →
        </a>
      </div>
    </slot>
  </div>
</template>

<script>
import { validateMobileWithCountry } from '../Common/utils.js';

export default {
  name: 'MobileStep',
  props: {
    countryCode: {
      type: String,
      default: '+86'
    },
    countryOptions: {
      type: Array,
      default: () => []
    },
    mobileNumber: {
      type: String,
      default: ''
    },
    mobileError: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    normalizedCountryOptions() {
      if (this.countryOptions && this.countryOptions.length > 0) {
        // 将 { value, text } 格式转换为 { id, label } 格式，以适配 selection 组件
        return this.countryOptions.map(option => ({
          id: option.value,
          label: option.text
        }));
      }
      return [];
    },
    // 统一的手机号基础格式校验：必须选择国家码 + 合法手机号
    isValidMobile() {
      return validateMobileWithCountry(this.countryCode, this.mobileNumber);
    }
  },
  methods: {
    handleInput(event) {
      const value = event.target.value.replace(/\s/g, '');
      event.target.value = value;
      this.$emit('update:mobileNumber', value);
    },
    handleCountryCodeInput(value) {
      // selection 组件的 @input 事件直接传递选中的值（id）
      this.$emit('update:countryCode', value);
    },
    handleCountrySelected(obj) {
      // selection 组件通过 fromChird_TreeSelected 事件传递 { id, label } 对象
      this.$emit('update:countryCode', obj.id);
    },
    handleEnter() {
      if (this.loading || !this.isValidMobile) {
        return;
      }
      this.$emit('continue');
    }
  }
};
</script>
<style>
/* 当 selection 组件内部的 vue-treeselect 获得焦点时，改变边框颜色 */
.mobile-country-select:focus-within .vue-treeselect__control,
.mobile-country-select .vue-treeselect--focused .vue-treeselect__control {
  outline: none;
  border-color: #7366FF !important;
}
</style>
<style scoped>
.login-step-mobile {
  gap: 16px;
}

.login-step-mobile form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.step-title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 28px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 36.40px;
  margin: 0;
  word-wrap: break-word;
}

@media (max-width: 768px) {
  .step-title {
    font-size: 24px;
    line-height: 31.20px;
  }
}

.form-group {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  gap: 16px;
}

.input-wrapper {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  display: flex;
  overflow: visible;
}

/* 确保标签样式与共享样式一致，使用更具体的选择器覆盖全局样式 */
.input-container-placeholder .input-label,
.input-wrapper .input-label {
  position: absolute;
  left: 12px;
  top: -5px;
  padding: 0 4px;
  background: white;
  display: inline-flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.60);
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 12px;
  height: 12px;
  letter-spacing: 0.15px;
  white-space: nowrap;
  z-index: 5;
  pointer-events: none;
  margin: 0;
  transform: translateY(0);
}

.form-input {
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background: #F8F7FF;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  color: rgba(0, 0, 0, 0.80);
  transition: border-color 0.2s, background 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #7366FF;
  background: white;
}

.country-select {
  cursor: pointer;
}

.input-container-placeholder {
  width: 100%;
  position: relative;
  overflow: visible;
}

/* .input-label 样式已移至共享样式文件 new-login-shared.css */
/* 如需特殊样式，请在此处添加覆盖 */

.input-container-placeholder.input-error {
  border-color: #CD1515;
}

.input-label.label-error {
  color: #D32F2F;
}

.input-placeholder {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
}

/* 输入框样式已移至共享样式文件 new-login-shared.css */
/* 如需特殊样式，请在此处添加覆盖 */

.input-container-select {
  position: relative;
  margin-bottom: 0;
  border: none !important;
  outline: none !important;
  padding: 0 !important;
  background: transparent !important;
  display: block !important;
}


.cu-form-label {
  position: absolute;
  left: 15px;
  top: -8px;
  padding: 0 5px;
  background-color: #F8F8F8;
  margin-bottom: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.80);
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
  font-weight: 400;
  line-height: 1.5;
  z-index: 10;
  pointer-events: none;
}

.cu-required {
  color: #CD1515;
  margin-left: 2px;
}

/* Select2 容器样式 */
.cu-form-select {
  width: 100%;
  padding: 12px 40px 12px 15px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
  background: white;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

.cu-form-select:focus {
  outline: none;
  border-color: #7366FF;
}

.input-container-select::after {
  content: '';
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid rgba(0, 0, 0, 0.54);
  pointer-events: none;
  z-index: 1;
}

.mobile-error-message {
  padding-left: 14px;
  padding-right: 14px;
  color: #D32F2F;
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  letter-spacing: 0.40px;
  word-wrap: break-word;
}

.btn-primary {
  width: 100%;
  padding: 16px 24px;
  background: #7366FF;
  color: white;
  border: none;
  border-radius: 999px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover:not(:disabled) {
  background: #5a4dcc;
  color: white;
  border: none;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #B8B3FF;
  color: rgba(255, 255, 255, 0.9);
}

.divider {
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(0, 0, 0, 0.10);
}

.divider span {
  color: rgba(0, 0, 0, 0.50);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 14px;
}

.alternative-login {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
}

.btn-secondary {
  align-self: stretch;
  height: 42px;
  padding: 0 24px;
  border-radius: 999px;
  outline: 1px rgba(0, 0, 0, 0.60) solid;
  outline-offset: -1px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  background: white;
  background-color: white;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 14px;
  word-wrap: break-word;
  box-sizing: border-box;
}

.btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03);
  background-color: rgba(0, 0, 0, 0.03);
  outline-color: rgba(0, 0, 0, 0.60);
}

.sso-login {
  width: 100%;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.sso-btn {
  flex: 1 1 0;
  height: 74px;
  background: rgba(0, 0, 0, 0.03);
  border: none;
  border-radius: 999px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.sso-btn:hover {
  background: rgba(0, 0, 0, 0.06);
}

.sso-btn svg,
.sso-btn img {
  width: 45px;
  height: 45px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
}

.become-supplier {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.become-supplier span {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.2px;
}

.supplier-link {
  color: #7366FF;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 18.2px;
  text-decoration: none;
}
</style>

<!-- 全局样式覆盖 -->
<style>
/* 引入共享样式 */
@import '../Common/new-login-shared.css';

.alternative-login .btn-secondary {
  background: white;
  background-color: white;
  border: none;
  color: rgba(0, 0, 0, 0.80);
}

.alternative-login .btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03);
  background-color: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.80);
}
</style>

